<div [class]="skinName">
  <form [formGroup]="feedbackGroup" (ngSubmit)="submitFeedback()">

    <div class="feedback-type text-center">
      <input id="bug" type="radio" formControlName="type" value="bug">
      <label for="bug">{{ configService.localeKeys?.['user_feedback.bug.text']}} &nbsp;&nbsp;</label>
      <input id="suggest" type="radio" formControlName="type" value="suggestion">
      <label for="suggest">{{ configService.localeKeys?.['user_feedback.suggestion.text']}}&nbsp;&nbsp;</label>
      <input id="other" type="radio" formControlName="type" value="other">
      <label for="other">{{ configService.localeKeys?.['user_feedback.other.text']}}&nbsp;&nbsp;</label>
    </div>
    <div class="input-container">
      <div class="form-fields" [hidden]="!guest">
        @if (feedbackGroup.controls.email) {
          <div class="align-input" [ngClass]="{'has-error':feedbackGroup.controls.email.invalid && !feedbackGroup.controls.email.pristine }">
            <!-- <label for="email">{{ configService.localeKeys.['common_keys.email.text'] }}</label> -->
            @if (feedbackGroup.controls.email.touched && feedbackGroup.get('email').hasError('required') ) {
              <p class="input-placeholder error-block">
              {{ configService.localeKeys?.['common_keys.email_required.text'] }}</p>
            }
            @if (feedbackGroup.controls.email.touched && !feedbackGroup.get('email').hasError('required') && feedbackGroup.get('email').hasError('pattern')) {
              <p class="input-placeholder error-block">
              {{ configService.localeKeys?.['common_keys.invalid_email.text']}}</p>
            }
            <div class="input-box-align">
              <input type="email" formControlName="email" name="email" class="form-control feedback-email" placeholder="{{ configService.localeKeys?.['account.enter_email.text']}}">
            </div>
          </div>
        }
      </div>
      <div class="form-fields">
        <div class="align-input" [ngClass]="{'has-error':feedbackGroup.controls.feedback.invalid && !feedbackGroup.controls.feedback.pristine }">
          <!-- <label for="feedback">{{ configService.localeKeys.['feedback.feedback.text'] }}</label> -->
          @if (feedbackGroup.controls.feedback.touched && feedbackGroup.get('feedback').hasError('required') ) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['feedback.feedback_is_empty.text']}}</p>
          }
          <div class="input-box-align">
            <textarea id="message" class="user-feedback-field" formControlName="feedback" name="feedback" autofocus="autofocus" required="required" placeholder="{{ configService.localeKeys?.['user_feedback.type_msg.text']}}...."></textarea>
          </div>
        </div>
      </div>
      <!-- <textarea id="message" class="user-feedback-field" formControlName="feedback" name="feedback" autofocus="autofocus" required="common_keys.field_required.text" placeholder="{{ configService.localeKeys?.['user_feedback.type_msg.text']}}...."></textarea>
      <input type="email" [hidden]="!guest" formControlName="email" name="email" class="form-control feedback-email" placeholder="{{ cconfigService.localeKeys?.['user_feedback.type_msg.text']}}"> -->
      <button type="submit" class="uk-button uk-button-default submit-btn">
        {{configService.localeKeys?.['user_feedback.send_feedback.text']}}
      </button>
    </div>
  </form>

</div>